/*
 *
 * File JS per la Homepage
 *
 */

import "./general.scss";

// IMPORT COMPONENTI
//--------------------------------------------------------------------//
import initHeader from "components/header/header";
import breadcrumbs from "components/breadcrumbs/breadcrumbs";
import button from "components/buttons/buttons";
import cmsContent from "components/cms-content/cms-content";
import footer from "components/footer/footer";
import contactForm from "components/contact-form/contact-form";
import textOnBg from "imComponents/text-on-bg/text-on-bg";
import heroSlider from "imComponents/hero-slider/hero-slider";
import textImgVar from "imComponents/text-img-var/text-img-var";
import accordion from "imComponents/accordion/accordion";
import boxGallery from "imComponents/box-gallery/box-gallery";
import sliderDinamic from "components/slider-dinamic/slider-dinamic";
import sliderStatic from "components/slider-static/slider-static";
import sliderNews from "components/slider-news/slider-news";
import sliderRooms from "components/slider-rooms/slider-rooms";
import sliderLocations from "components/slider-locations/slider-locations";
import sliderReviews from "components/slider-reviews/slider-reviews";
import cardRoom from "components/cards/card-room";
import cardLocation from "components/cards/card-location";
import cardNews from "components/cards/card-news";
import cardReview from "components/cards/card-review";
import galleryText from "components/gallery-text/gallery-text";
import boxMap from "components/box-map/box-map";
import textIframe from "components/text-iframe/text-iframe";
import cardReadMore from "components/cards/card-read-more";
import archiveFilters from "components/archive-filters/archive-filters";
import archiveList from "components/archive-list/archive-list";
//--------------------------------------------------------------------//

// INIT COMPONENTI
//--------------------------------------------------------------------//
accordion();
initHeader();
heroSlider();
boxGallery();
sliderRooms();
sliderLocations();
sliderReviews();
archiveFilters();
sliderNews();
//--------------------------------------------------------------------//
